__turbopack_context__.v({
  "slider": "SectionCarouselItems-module-sass-module__5bAZcq__slider",
});
